import { ProductConfiguratorGenericServices } from "./api-connector";

export const currencyServices = new ProductConfiguratorGenericServices(`/api/currency`);
